export enum CaseScannerModal {
  CASE_SCANNER_DUPLICATE_LABEL_PALLET = "CASE_SCANNER_DUPLICATE_LABEL_PALLET",
  CASE_SCANNER_DUPLICATE_LABEL_CONFIRMATION = "CASE_SCANNER_DUPLICATE_LABEL_CONFIRMATION",
  CASE_SCANNER_DUPLICATE_LABEL_PROMPT = "CASE_SCANNER_DUPLICATE_LABEL_PROMPT",
}
